/**
 * @generated SignedSource<<9711ab348bd1db557046592b2425d962>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type checkRefundHistoryQuery$variables = Record<PropertyKey, never>;
export type checkRefundHistoryQuery$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly corps: ReadonlyArray<{
        readonly __typename: "RefundHistoryType";
      }> | null | undefined;
      readonly indis: ReadonlyArray<{
        readonly __typename: "RefundHistoryType";
      }> | null | undefined;
      readonly previousIndis: ReadonlyArray<{
        readonly __typename: "RefundHistoryType";
      }> | null | undefined;
      readonly tritxIndis: ReadonlyArray<{
        readonly __typename: "RefundHistoryType";
      }> | null | undefined;
    };
  };
};
export type checkRefundHistoryQuery = {
  response: checkRefundHistoryQuery$data;
  variables: checkRefundHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "checkRefundHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BznavRefundOutput",
        "kind": "LinkedField",
        "name": "bznavRefund",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundUserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "indis",
                "plural": true,
                "selections": (v1/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "corps",
                "plural": true,
                "selections": (v1/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "previousIndis",
                "plural": true,
                "selections": (v1/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "tritxIndis",
                "plural": true,
                "selections": (v1/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "checkRefundHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BznavRefundOutput",
        "kind": "LinkedField",
        "name": "bznavRefund",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundUserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "indis",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "corps",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "previousIndis",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "tritxIndis",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2a87b213284222ca332d030a295e8e53",
    "id": null,
    "metadata": {},
    "name": "checkRefundHistoryQuery",
    "operationKind": "query",
    "text": "query checkRefundHistoryQuery {\n  bznavRefund {\n    user {\n      indis {\n        __typename\n        id\n      }\n      corps {\n        __typename\n        id\n      }\n      previousIndis {\n        __typename\n        id\n      }\n      tritxIndis {\n        __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d175098c97dad78afeea52923c71201";

export default node;
